import React from 'react';
import PropTypes from 'prop-types';
import SvgImg from '../components/Svg/SvgImg';

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */

const Rakuten = ({ width, height }) => (
  <SvgImg viewbox="0 0 338 80" title="logo / rakuten" width={width} height={height} preserveAspectRatio="xMinYMin meet">
    <path
      d="M25.512 13.002c0 7.044-5.711 12.753-12.757 12.753S0 20.046 0 13.002 5.706.243 12.755.243a12.76 12.76 0 0 1 12.757 12.759"
      fill="#bf0000"
    />
    <path
      d="M11.069 8.749h1.7a2.13 2.13 0 0 1 2.126 2.124 2.13 2.13 0 0 1-2.126 2.126h-1.7v-4.25zm0 11.106v-4.252h1.842l3.19 4.252h3.261l-3.855-5.13c1.202-.863 1.991-2.265 1.991-3.852 0-2.608-2.121-4.727-4.729-4.727H8.464v13.709h2.605z"
      fill="#fff"
    />
    <g fill="#000">
      <path d="M111.639 19.364c-.236.495-.762 1.218-1.826 1.218-.682 0-1.966-.457-1.966-2.192v-7.929h6.427V6.098h-6.427v-4.58h-4.364v4.58h-3.097v4.363h3.097v7.929c-.001 4.104 3.219 6.556 6.33 6.556 3.183 0 5.293-2.167 6.076-4.44l-4.25-1.142zM53.5 20.568c-2.34 0-4.245-2.368-4.245-5.279s1.905-5.277 4.245-5.277 4.249 2.368 4.249 5.277-1.906 5.279-4.249 5.279h0zm4.249-14.47v.816c-1.258-.801-2.705-1.267-4.249-1.267-4.746 0-8.606 4.327-8.606 9.642s3.86 9.641 8.606 9.641c1.544 0 2.991-.464 4.249-1.266v.815h4.363V6.098h-4.363zm36.747 0v10.797c0 2.026-1.646 3.673-3.673 3.673a3.68 3.68 0 0 1-3.673-3.673V6.098h-4.363v10.797c0 4.431 3.605 8.035 8.036 8.035 1.323 0 2.57-.326 3.673-.896v.444h4.362V6.098h-4.362zm48.786-.451a7.99 7.99 0 0 0-3.671.896v-.445h-4.363v18.381h4.363V13.684c0-2.028 1.646-3.676 3.671-3.676a3.68 3.68 0 0 1 3.673 3.676v10.795h4.363V13.684a8.05 8.05 0 0 0-8.036-8.037" />
      <path d="M128.569 12.673h-7.357c.817-3.574 6.547-4.318 7.357 0m4.933 2.616c0-5.324-3.863-9.657-8.61-9.657-4.828 0-8.61 4.243-8.61 9.657 0 5.693 4.856 9.658 9.214 9.658 2.2 0 5.213-.754 7.581-4.114l-3.799-2.194c-3.222 3.936-7.712 1.264-8.16-2.066l12.299.003c.049-.428.085-.858.085-1.287m-60.204-.575l8.617-8.616h-6.17l-6.652 6.655V0H64.73v24.479h4.363v-7.802l7.8 7.802h6.167zM32.426 5.878h2.847c1.959 0 3.561 1.594 3.561 3.557a3.57 3.57 0 0 1-3.561 3.56h-2.847V5.878zm0 18.601v-7.121h3.086l5.342 7.121h5.462l-6.456-8.592c2.012-1.445 3.333-3.793 3.333-6.452 0-4.369-3.552-7.916-7.92-7.916h-7.21v22.96h4.363z" />
    </g>
  </SvgImg>
);
Rakuten.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

Rakuten.defaultProps = {
  width: undefined,
  height: undefined,
};
export default Rakuten;
